import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate } from "react-redux-i18n";
import Layout from "../Layouts/LayoutMain";
import SupportTile from "../Components/Support/SupportTile";
import { PageTitle } from "../Components/Common/PageTitle";
import { ContentContainer } from "../Components/Common/ContentContainer";
import { updateChatState } from "../Store/Chat/Actions";

// Modal.setAppElement('#yourAppElement');

class Support extends Component {
    render() {
        const { updateChatState } = this.props;

        return (
            <Layout>
                <PageTitle title="support.title"/>
                <ContentContainer>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div>
                                <h3 className="m-0">
                                    <Translate value="support.options.title" />
                                </h3>
                                <hr className="my-1"/>
                                {/* <div className="row mt-2">
                                    <div className="col-sm-3 text-left">
                                        <p className="font-weight-bold">
                                            <Translate value="misc.chat" />:
                                        </p>
                                    </div>
                                    <div className="col-sm-9 text-left">
                                        <Link to="#" onClick={() => updateChatState(true)} style={{ color: "#4a90e2", cursor: "pointer" }}>
                                            <Translate value="misc.liveChat" />
                                        </Link>
                                    </div>
                                </div> */}
                                <div className="row mt-3">
                                    <div className="col-sm-3 text-left">
                                        <p className="font-weight-bold m-0">
                                            <Translate value="misc.phone" />:
                                        </p>
                                    </div>
                                    <div className="col-sm-9 text-left">
                                        <p className="m-0">
                                            877-492-8808
                                        </p>
                                        <p className="m-0">
                                            PIN: 122
                                        </p>
                                        <p>
                                            Option: 1
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-3 text-left">
                                        <p className="font-weight-bold">
                                            <Translate value="misc.email" />:
                                        </p>
                                    </div>
                                    <div className="col-sm-9 text-left">
                                        <a href="mailto:Insidesales@velocitor.com?Subject=Sales%20Support" target="_top">Insidesales@velocitor.com</a>
                                    </div>
                                </div>
                                <div className="row mt-3 mb-5">
                                    <div className="col-sm-3 text-left">
                                        <p className="font-weight-bold">
                                            <Translate value="misc.hours" />:
                                        </p>
                                    </div>
                                    <div className="col-sm-9 text-left">
                                        <p><Translate value="misc.salesHours" /></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-8">
                            <div className="row">
                                <div className="col-12 col-md-4 mb-4">
                                    <SupportTile title="misc.phone" identifier={1} image={require("../../Assets/Images/phone.png")} description="support.phone" />
                                </div>
                                {/* <div className="col-12 col-md-4 mb-4">
                                    <SupportTile title="misc.chat" identifier={2} image={require("../../Assets/Images/chat.png")} description="support.chat"/>
                                </div> */}
                                <div className="col-12 col-md-4 mb-4">
                                    <SupportTile title="misc.email" identifier={3} image={require("../../Assets/Images/mail.png")} description="support.email"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentContainer>
            </Layout>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateChatState: updateChatState
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(Support);